// extracted by mini-css-extract-plugin
module.exports = {"itemIcon":"styles_itemIcon__VW4oh","defaultName":"styles_defaultName__Q1DZf","hide":"styles_hide__M3zM4"};